export default "__VITE_ASSET__CmMdGedz__"